<template>
  <div>
    <v-app-bar dense dark color="primary" app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <div class="d-flex align-center ml-11">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="@/assets/logo.png"
          transition="scale-transition"
          width="40"
        />

        <span>SI PAKAR SINGKONG</span>
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div>
            <v-btn icon dark v-on="on" @click="logout">
              <v-icon small dark>exit_to_app</v-icon>
            </v-btn>
          </div>
        </template>
        <span>Keluar dari dashboard sistem.</span>
      </v-tooltip>
    </v-app-bar>
    <v-navigation-drawer app width="333" v-model="drawer" class="pa-0 ma-0">
      <v-container fluid>
        <div class="pt-7 ma-0">
          <v-row justify="center" align="center">
            <v-img src="@/assets/logo.png" max-width="150" max-height="150"></v-img>
          </v-row>

          <!-- tipe -->
          <v-row justify="center" align="center" class="mt-7">
            <span class="heading">
              {{
              $store.getters.user.nama
              }}
            </span>
          </v-row>
          <v-row justify="center" align="center" class="mt-2">
            <span class="grey--text caption">Administrator</span>
          </v-row>
        </div>

        <v-divider class="my-3" dark></v-divider>

        <div v-for="(item, index) in menu" :key="index">
          <v-list-group
            :group="attractions"
            v-if="item.items"
            v-model="item.active"
            :prepend-icon="item.icon"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="subItem in item.items" :key="subItem.text" :to="subItem.link">
              <v-list-item-icon>
                <v-icon v-text="subItem.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="caption">{{subItem.text}}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item v-else :to="item.link">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <span class="heading">{{ item.text }}</span>
            </v-list-item-content>
          </v-list-item>
        </div>

        <v-row justify="center" align="center" class="mt-7">
          <span class="grey--text caption">Created By : ua4ever</span>
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
import bus from "@/main";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      drawer: true,
      menu: [
        {
          icon: "dashboard",
          text: "Dashboard",
          link: "/dashboard"
        },
        {
          icon: "mdi-bacteria",
          text: "Daftar Gejala",
          link: "/gejala"
        },
        {
          icon: "mdi-virus",
          text: "Daftar Penyakit",
          link: "/penyakit"
        },
        {
          icon: "mdi-history",
          text: "Histori Pengguna",
          link: "/diagnosa"
        }
      ]
    };
  },
  methods: {
    logout: async function() {
      const y = await Swal.fire({
        icon: "question",
        text: "Anda yakin ingin keluar dari sistem ?",
        title: "Exit",
        showCancelButton: true,
        cancelButtonText: "Tidak",
        cancelButtonColor: "teal",
        confirmButtonText: "Ya",
        confirmButtonColor: "red"
      });

      if (y.value) {
        await this.$store.dispatch("logout");
        bus.$emit("authChanged");
      }
    }
  }
};
</script>
